import { createAction } from 'redux-actions';
import {
  Card,
  City,
  CompanyNotification,
  ItemConnectionSort
} from '../graphql/types';
import { FullItemData } from '../components/Ad/Sections/CurrentItemSections/types';
import {
  FailurePaymentModalViewState,
  NotificationState,
  PaymentSuccessData,
  ResultByNumber,
  SuccessPromotionModalViewState
} from '../store/types';
import { SearchFormValues } from '../utils/helpers/search';

export const toggleDrawer = createAction<boolean | undefined>('DRAWER_TOGGLE');
export const toggleAuthModal = createAction<boolean | undefined>(
  'AUTH_MODAL_TOGGLE'
);
export const setEmail = createAction<string>('AUTH_MODAL_SET_EMAIL');

export const setNotification = createAction<Partial<NotificationState>>(
  'AUTH_MODAL_SET_NOTIFICATION'
);
export const closeNotification = createAction<void>(
  'AUTH_MODAL_CLOSE_NOTIFICATION'
);
export const clearNotificationMessage = createAction<void>(
  'AUTH_MODAL_CLEAR_NOTIFICATION_MESSAGE'
);

export const toggleSideMenuModal = createAction<boolean | undefined>(
  'SIDE_MENU_MODAL_TOGGLE'
);
export const togglePromotionModalView = createAction<boolean | undefined>(
  'PROMOTION_MODAL_VIEW_TOGGLE'
);
export const setProfilePromotionItemId = createAction<
  string | null | undefined
>('SET_PROFILE_PROMOTION_ITEM_ID');
export const toggleRestoreAlertModal = createAction<boolean | undefined>(
  'RESTORE_ALERT_MODAL_TOGGLE'
);
export const openSuccessPromotionAlertModal = createAction<string | undefined>(
  'OPEN_SUCCESS_PROMOTION_ALERT_MODAL'
);
export const closeSuccessPromotionAlertModal = createAction(
  'CLOSE_SUCCESS_PROMOTION_ALERT_MODAL'
);
export const setSuccessPromotionItemData = createAction<
  SuccessPromotionModalViewState['itemData']
>('SET_SUCCESS_PROMOTION_ITEM_DATA');
export const toggleRefetchModalData = createAction<boolean>(
  'TOGGLE_REFETCH_MODAL_DATA'
);
export const toggleAddNewItemModal = createAction<boolean | undefined>(
  'ADD_NEW_ITEM_MODAL_TOGGLE'
);
export const setCreationResetButtonIsDisabled = createAction<boolean>(
  'SET_CREATION_RESET_BUTTON_IS_DISABLED'
);
export const setIsBannedUser = createAction<boolean>('SET_IS_BANNED_USER');
export const openFailurePaymentAlertModal =
  createAction<FailurePaymentModalViewState>(
    'OPEN_FAILURE_PAYMENT_ALERT_MODAL'
  );
export const openItemsBalanceModal = createAction<boolean>(
  'OPEN_ITEMS_BALANCE_MODAL'
);
export const openBuyItemsModal = createAction<boolean>('OPEN_BUY_ITEMS_MODAL');
export const openWalletPayModal = createAction<boolean>(
  'OPEN_WALLET_PAY_MODAL'
);
export const openPersonalAccountModal = createAction<boolean>(
  'OPEN_PERSONAL_ACCOUNT_MODAL'
);
export const toggleProfilePromotionItemsModal = createAction<boolean>(
  'TOGGLE_PROFILE_PROMOTION_ITEMS_MODAL'
);
export const openTerminalModal = createAction<boolean>('OPEN_TERMINAL_MODAL');
export const openPackagePayModal = createAction<boolean>(
  'OPEN_PACKAGE_PAY_MODAL'
);

export const openSuccessWebViewPaymentStatusAlertModal =
  createAction<PaymentSuccessData | null>(
    'OPEN_SUCCESS_WEBVIEW_PAYMENT_STATUS_ALERT_MODAL'
  );
export const closeSuccessWebViewPaymentStatusAlertModal = createAction<void>(
  'CLOSE_SUCCESS_WEBVIEW_PAYMENT_STATUS_ALERT_MODAL'
);
export const openFailureWebViewPaymentStatusAlertModal = createAction<{
  isVisible: boolean;
  type: string;
  shouldReload?: boolean;
  errorMessage?: string | null;
}>('OPEN_FAILURE_WEBVIEW_PAYMENT_STATUS_ALERT_MODAL');

export const setBlockerDetector = createAction<boolean>('SET_BLOCKER_DETECTOR');
export const switchTab = createAction<number>('SEARCH_FORM_SWITCH_TAB');
export const setSearchSort =
  createAction<ItemConnectionSort>('SET_SEARCH_SORT');
export const showPopupHeader = createAction<void>('SHOW_POPUP_HEADER');
export const hidePopupHeader = createAction<void>('HIDE_POPUP_HEADER');
export const setCurrentCity = createAction<string>('SET_CURRENT_CITY');
export const setSearchValues =
  createAction<SearchFormValues>('SET_SEARCH_VALUES');
export const setResetPopupHandler = createAction<(() => void) | null>(
  'SET_RESET_POPUP_HANDLER'
);
export const setLocationsResetButtonIsDisabled = createAction<boolean>(
  'SET_LOCATIONS_RESET_BUTTON_IS_DISABLED'
);
export const setResetButtonIsDisabled = createAction<boolean>(
  'SET_RESET_BUTTON_IS_DISABLED'
);
export const toggleAuthWindow = createAction<boolean | undefined>(
  'TOGGLE_AUTH_WINDOW'
);
export const setChosenLocationNames = createAction<string[]>(
  'SET_CHOSEN_LOCATION_NAMES'
);
export const setLocationIds = createAction<string[]>('SET_LOCATION_IDS');
export const setCitiesList =
  createAction<Omit<City, 'locations' | 'path'>[]>('SET_CITIES_LIST');
export const setCurrentState = createAction<SearchFormValues | null>(
  'SET_CURRENT_STATE'
);
export const setError = createAction<boolean>('SET_ERROR');
export const setProfileAuth = createAction<boolean>('SET_PROFILE_AUTH');
export const setIsLoadingResultByNumber = createAction<boolean>(
  'SET_IS_LOADING_RESULT_BY_NUMBER'
);
export const setResultByNumber = createAction<ResultByNumber>(
  'SET_RESULT_BY_NUMBER'
);
export const setCategoryIds =
  createAction<(string | undefined)[]>('SET_CATEGORY_IDS');
export const showProfileEditSuccessMessage = createAction<boolean>(
  'SHOW_PROFILE_EDIT_SUCCESS_MESSAGE'
);
export const setReplenishmentNotifications = createAction<
  CompanyNotification[] | undefined
>('SET_NOTIFICATIONS');
export const toggleReplenishmentNotificationsModal = createAction<
  boolean | undefined
>('TOGGLE_NOTIFICATIONS_MODAL');
export const setAdriverSelectedCity = createAction<string>(
  'SET_ADRIVER_SELECTED_CITY'
);
export const setUserCardsState = createAction<Card[]>('SET_USER_CARDS');
export const setCurrentItemAuthModalOpen = createAction<boolean>(
  'SET_CURRENT_ITEM_AUTH_MODAL_OPEN'
);
export const setCurrentItem =
  createAction<NonNullable<FullItemData>>('SET_CURRENT_ITEM');
export const setProfileTransfersModalVisible = createAction<boolean>(
  'SET_PROFILE_TRANSFERS_MODAL_VISIBLE'
);
export const setProfileMenuModalVisible = createAction<boolean>(
  'SET_PROFILE_MENU_MODAL_VISIBLE'
);
export const setModalLock = createAction<number>('SET_MODAL_LOCK');
